var _templateObject = _taggedTemplateLiteralLoose(['\n  padding-top: 8px;\n  padding-bottom: 8px;\n  color: ', ';\n  font-weight: bold;\n  font-family: ', ';\n  font-size: 24px;\n  line-height: 1.46;\n  letter-spacing: -0.2px;\n'], ['\n  padding-top: 8px;\n  padding-bottom: 8px;\n  color: ', ';\n  font-weight: bold;\n  font-family: ', ';\n  font-size: 24px;\n  line-height: 1.46;\n  letter-spacing: -0.2px;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  font-family: ', ';\n  font-weight: 500;\n  font-size: 12px;\n  text-align: left;\n  line-height: 2;\n'], ['\n  color: ', ';\n  font-family: ', ';\n  font-weight: 500;\n  font-size: 12px;\n  text-align: left;\n  line-height: 2;\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex: 1;\n  padding: 0 20px;\n  margin: 10px 0;\n  @media(max-width: 767px){\n    width: 100%;\n    flex: none;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex: 1;\n  padding: 0 20px;\n  margin: 10px 0;\n  @media(max-width: 767px){\n    width: 100%;\n    flex: none;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: ', ';\n  ', ';\n\n  @media(max-width: 767px){\n    width: 100%;\n    padding: 15px 30px;\n    flex: none;\n  }\n'], ['\n  display: flex;\n  flex-direction: ', ';\n  ', ';\n\n  @media(max-width: 767px){\n    width: 100%;\n    padding: 15px 30px;\n    flex: none;\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { primary, lightBlue } from '../../assets/colors';
import { PlayfairDisplay, Montserrat } from '../../assets/fonts';

var TitleFrame = styled.h4(_templateObject, primary, PlayfairDisplay);

var LinkFrame = styled.a(_templateObject2, function (props) {
  return props.lightBlue;
}, Montserrat);

var ResourceCardBox = styled.div.attrs({
  className: 'resource-card'
})(_templateObject3);

var ResourceCardContent = styled.div(_templateObject4, function (_ref) {
  var vertical = _ref.vertical;
  return vertical ? 'row' : 'column';
}, function (_ref2) {
  var vertical = _ref2.vertical;
  return !vertical && 'margin: 0 auto';
});

var ResourcesCardDefinition = function ResourcesCardDefinition(_ref3) {
  var _ref3$resource = _ref3.resource,
      id = _ref3$resource.id,
      label = _ref3$resource.label,
      items = _ref3$resource.items,
      user = _ref3$resource.user,
      icon = _ref3$resource.icon,
      vertical = _ref3.vertical;
  return React.createElement(
    ResourceCardBox,
    null,
    React.createElement(
      ResourceCardContent,
      { vertical: vertical },
      React.createElement(
        'div',
        null,
        icon && icon()
      ),
      React.createElement(
        'div',
        null,
        React.createElement(
          TitleFrame,
          null,
          label
        ),
        items && items.map(function (item) {
          return typeof item.comp === 'function' ? item.comp() : React.createElement(
            'div',
            { key: item.label },
            React.createElement(
              LinkFrame,
              { pgaBlue: primary, lightBlue: lightBlue, href: item.url, target: item.target, rel: 'noopener noreferrer' },
              item.label
            )
          );
        })
      )
    )
  );
};

ResourcesCardDefinition.displayName = 'ResourcesCard';
ResourcesCardDefinition.propTypes = process.env.NODE_ENV !== "production" ? {
  resource: PropTypes.shape({
    id: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      type: PropTypes.string,
      url: PropTypes.url,
      target: PropTypes.target
    })).isRequired
  }).isRequired,
  vertical: PropTypes.bool
} : {};

export default ResourcesCardDefinition;